import * as React from "react";
import Layout from "../components/ui/layout";
import Nieuws from "../components/content/nieuws";
import Lokaalenbestuur from "../components/content/lokaalenbestuur";
import Vluchtprogramma from "../components/content/vluchtprogramma";
import Kampioenschap from "../components/content/kampioenschap";
import Lidmaatschap from "../components/content/lidmaatschap";
import Links from "../components/content/links";

const getType = (type) => {
  switch (type) {
    case "nieuws":
      return <Nieuws data={type} />;
    case "lokaalenbestuur":
      return <Lokaalenbestuur data={type} />;
    case "vluchtprogramma":
      return <Vluchtprogramma data={type} />;
    case "kampioenschap":
      return <Kampioenschap data={type} />;
    case "lidmaatschap":
      return <Lidmaatschap data={type} />;
    case "links":
      return <Links data={type} />;
    default:
      return type;
  }
};

const Page = ({ pageContext }) => {
  return (
    <Layout data={pageContext}>
      <div>{getType(pageContext.Slug)}</div>
    </Layout>
  );
};

export const Head = ({ pageContext }) => (
  <>
    <html lang="nl" />
    <title>{"De Vrijheid | " + pageContext.title}</title>
  </>
);
export default Page;
